(function ($, w, u) {
    var AjaxComments = function (token, containerSelector) {
        this.form = $('');
        this.token = token;
        this.commentsContainer = $('');
        this.showMoreButton = $('');
        this.container = $(containerSelector);
    };
    var lastInstance = null;

    AjaxComments.instances = {};
    AjaxComments.getInstance = function (token, containerSelector) {
        if (token == u) {
            return lastInstance;
        }
        if (this.instances[token]) {
            lastInstance = this.instances[token];
            if (containerSelector) {
                lastInstance.container = $(containerSelector);
            }
            return lastInstance;
        }
        return lastInstance = this.instances[token] = new this(token, containerSelector);
    };

    AjaxComments.prototype = {

        initComments: function (commentsContainerSelector, showMoreButtonSelector) {

            this.commentsContainer = $(commentsContainerSelector);
            this.showMoreButton = $(showMoreButtonSelector);
            var self = this;
            var isLoading = false;
            this.showMoreButton.on('click', function () {
                if (self.trigger('beforeLoadComments') === false) {
                    return false;
                }
                var me = $(this),
                    href = me.data('href');

                if (!isLoading) {
                    me.addClass('__disabled');
                    isLoading = true;

                    sendAjax(href, {}, function (status, response) {
                        me.removeClass('__disabled');
                        isLoading = false;
                        if (status === "OK") {
                            self.commentsContainer.append(response.html);
                            self.initReply();
                            if (response.show_more) {
                                me.data('href', response.next_uri);
                            } else {
                                me.parent().remove();
                            }
                        }
                        self.trigger('afterLoadComments', status, response);
                    });
                }

                return false;
            });

            this.initReply()
        },

        initForm: function (selector) {
            var self = this;
            this.form = $(selector);
            this.submitting = false;
            var inputs = this.form.find(':input');

            this.form.off('submit').on('submit', function () {
                if (self.submitting) {
                    self.trigger('submitPending');
                    return false;
                }
                if (self.trigger('beforeSubmit') === false) {
                    self.trigger('abortSubmit');
                    return false;
                }
                self.submitting = true;
                var action = $(this).attr('data-action'),
                    data = $(this).serializeArray();
                data.push({
                    'name'  : 'token',
                    'value' : self.token
                });

                sendAjax(action, data, function (status, response) {
                    self.submitting = false;
                    inputs.errorBox();
                    self.trigger('afterSubmit', status, response);
                    if (status === 'VALIDATION_ERROR') {
                        for (var i in response.errors) {
                            if (response.errors.hasOwnProperty(i)) {
                                var code = response.errors[i].code,
                                    message = response.errors[i].message;

                                inputs.filter('[name="form[' + code + ']"]').errorBox(message);
                            }
                        }

                        self.trigger('onCommentError');
                    } else if (status === "OK") {
                        self.form.reset();
                        if (response.CSRFToken) {
                            self.form.find('input[name="CSRFToken"]').val(response.CSRFToken);
                        }
                        self.trigger('onCommentSuccess');
                        self.updateComments(response);
                    }
                });

                return false;
            });
        },

        initReply: function () {
            var self = this;
            var click = function () {
                var me = $(this),
                    href = me.data('href'),
                    replyTo = me.attr('data-reply') * 1,
                    hide = self.commentsContainer.find('.j-hide-' + replyTo),
                    formSelector = '#reply-form-' + replyTo,
                    formContainer = self.commentsContainer.find('.j-reply-form-' + replyTo),
                    form;

                self.trigger('beforeReplyInit', replyTo, me);
                sendAjax(href, function (status, response) {
                    if (status === 'OK') {
                        form = $(response.form);
                        formContainer.empty().append(form);

                        formContainer.show();
                        self.trigger('afterReplyInit', replyTo, me);
                        self.initReplyForm(formSelector);
                        var textValue = form.find(':input:visible:first').val();
                        form
                            .find(':input:visible:first')
                            .selectRange(textValue.length, textValue.length)
                            .focus();
                    }
                });

                return false;
            };
            this.commentsContainer.find('.j-reply').off('click.initReply').on('click.initReply', click);
        },

        initReplyForm: function (selector) {
            var self = this,
                submitting = false;

            this.replyForm = $(selector);
            this.replyForm.off('submit').on('submit', function () {
                if (self.trigger('beforeReply') === false) {
                    self.trigger('abortReply');
                    return false;
                }
                var replyTo = self.replyForm.attr('data-reply'),
                    commentId = self.replyForm.attr('data-comment'),
                    hide = self.commentsContainer.find('.j-hide-' + commentId),
                    formContainer = self.commentsContainer.find('.j-reply-form-' + commentId);
                if (!submitting) {
                    submitting = true;
                    var data = self.replyForm.serializeArray(),
                        inputs = self.replyForm.find(':input'),
                        enabledFields = self.replyForm.find(':input:enabled');

                    data.push({
                        'name'  : 'token',
                        'value' : self.token
                    });

                    enabledFields.prop('disabled', true).attr('disabled', 'disabled');

                    sendAjax(self.replyForm.attr('data-action'), data, function (status, response) {
                        self.trigger('afterReply', status, response);
                        submitting = false;
                        enabledFields.prop('disabled', false).removeAttr('disabled');
                        if (status === 'VALIDATION_ERROR') {
                            for (var i in response.errors) {
                                if (response.errors.hasOwnProperty(i)) {
                                    var code = response.errors[i].code,
                                        message = response.errors[i].message;

                                    inputs.filter('[name="form[' + code + ']"]').errorBox(message);
                                }
                            }

                        } else if (status === "OK") {
                            formContainer.hide();
                            self.replyForm.reset();
			                hide.show();
                            hide.removeClass('__disabled');
                            var obj = $(response.comment_html);
                            self.commentsContainer.find('.j-comment-root-' + replyTo).append(obj);
                            self.initReply();
                            self.trigger('onReplySuccess');
                            //var top = obj.offset().top;
                            //$(window).scrollTop(top);
                        }
                    });
                }

                return false;
            });
        },

        updateComments: function (response) {
            var obj = $(response.comment_html);

            if (response.comments_count === 1) {
                reloadPage();
                return;
            }
            this.commentsContainer.prepend(obj);
            var top = obj.offset().top;
            $(window).scrollTop(top);

            this.initReply();
            this.trigger('onUpdateComments', response.comments_count, response.avg_rate);
        },

        initSorting: function (triggerSelector) {
            document.querySelectorAll(triggerSelector)
                .forEach((button) => {
                    button.addEventListener('click', (e) => {
                        const self = this;
                        e.preventDefault();

                        this.trigger('beforeSorting');
                        sendAjax(button.dataset.href, {}, function (status, response) {
                            if (status === 'OK') {
                                self.container.html($(response.html).children());
                                window.history.pushState({}, response.page.title, response.page.url);
                            }
                            self.trigger('afterSorting');
                        });
                    });
                });
        }
    };

    $.extend(AjaxComments.prototype, TMEvents);

    w.AjaxComments = AjaxComments;
})(jQuery, window, undefined);